import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { FeatureProvider } from "@/contexts/FeatureContext";

import PublicLayout from "@/layouts/PublicLayout";
import AdminLayout from "@/layouts/AdminLayout";

import Home from "@/pages/public/Home";
import Restaurant from "@/pages/public/Restaurant";
import Grocery from "@/pages/public/Grocery";
import DailyMenu from "@/pages/public/DailyMenu";
import Promotions from "@/pages/public/Promotions";
import Catering from "@/pages/public/Catering";
import Lechon from "@/pages/public/Lechon";
import Rewards from "@/pages/public/Rewards";
import Contact from "@/pages/public/Contact";
import Cart from "@/pages/public/Cart";
import Checkout from "@/pages/public/Checkout";
import OrderReceipt from "@/pages/public/OrderReceipt";
import Login from "@/pages/public/Login";
import Register from "@/pages/public/Register";

import CustomerDashboard from "@/pages/customer/Dashboard";

import AdminDashboard from "@/pages/admin/Dashboard";
import POS from "@/pages/admin/POS";
import POSSettings from "@/pages/admin/POSSettings";
import Orders from "@/pages/admin/Orders";
import Kitchen from "@/pages/admin/Kitchen";
import Picking from "@/pages/admin/Picking";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminDailyMenu from "@/pages/admin/AdminDailyMenu";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminPromotions from "@/pages/admin/AdminPromotions";
import AdminPopups from "@/pages/admin/AdminPopups";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminLechon from "@/pages/admin/AdminLechon";
import AdminCatering from "@/pages/admin/AdminCatering";
import FeatureControls from "@/pages/admin/FeatureControls";
import AdminBranding from "@/pages/admin/AdminBranding";

function RequireStaff({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-center text-[#FAF9F6]/40 admin-bg min-h-screen">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "customer") return <Navigate to="/account" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FeatureProvider>
          <CartProvider>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/restaurant" element={<Restaurant />} />
                <Route path="/grocery" element={<Grocery />} />
                <Route path="/daily-menu" element={<DailyMenu />} />
                <Route path="/promotions" element={<Promotions />} />
                <Route path="/catering" element={<Catering />} />
                <Route path="/lechon" element={<Lechon />} />
                <Route path="/rewards" element={<Rewards />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:id" element={<OrderReceipt />} />
                <Route path="/account" element={<CustomerDashboard />} />
              </Route>

              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/admin" element={<RequireStaff><AdminLayout /></RequireStaff>}>
                <Route index element={<AdminDashboard />} />
                <Route path="branding" element={<AdminBranding />} />
                <Route path="pos" element={<POS />} />
                <Route path="pos-settings" element={<POSSettings />} />
                <Route path="orders" element={<Orders />} />
                <Route path="kitchen" element={<Kitchen />} />
                <Route path="picking" element={<Picking />} />
                <Route path="menu" element={<AdminMenu />} />
                <Route path="daily-menu" element={<AdminDailyMenu />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="promotions" element={<AdminPromotions />} />
                <Route path="popups" element={<AdminPopups />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="lechon" element={<AdminLechon />} />
                <Route path="catering" element={<AdminCatering />} />
                <Route path="features" element={<FeatureControls />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </CartProvider>
        </FeatureProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
